import { Box } from '@mui/material';
import type { DataSourceLayout__DataSource as DataSource } from '../../queries/layout.generated';
import { ExportButton } from './ExportButton';
import { SyncButton } from './SyncButton';
import { UploadButton } from './UploadButton';

interface ActionsProps {
  dataSource: DataSource;
}

export const Actions = ({ dataSource }: ActionsProps) => {
  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <ExportButton dataSourceId={dataSource.id} />
      {dataSource.kind === 'INTEGRATION' && <SyncButton dataSource={dataSource} />}
      {dataSource.kind !== 'INTEGRATION' && <UploadButton dataSource={dataSource} />}
    </Box>
  );
};
